import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  standalone: false,
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

  fa: any;
  activeUrl = '';
  pageTitle = 'Dashboard';
  user: any;

  sideMenu: any = [

    {
      title: 'Operations', path: '', visible: true,
      menu: [
        { title: 'Dashboard', path: '/app', icon: 'bi bi-graph-up' },
        { title: 'Customers', path: '/app/customers', icon: 'bi bi-people' },
        // { title: 'Customer Limits', path: '/app/customer-limits', icon: 'bi bi-wallet2' },
        { title: 'Transactions', path: '/app/transactions', icon: 'bi bi-database' },
        { title: 'Disputes', path: '/app/disputes', icon: 'bi bi-bug-fill' },
        { title: 'Refunds', path: '/app/refunds', icon: 'bi bi-arrow-counterclockwise' },
      ]
    },
    {
      title: 'Partners', path: '', visible: true,
      menu: [
        { title: 'Partners', path: '/app/partners', icon: 'bi bi-people' },
        { title: 'Partner Limits', path: '/app/partner-limits', icon: 'bi bi-wallet2' },
        { title: 'Rate Conversion', path: '/app/conversion', icon: 'bi bi-currency-exchange' },
        // { title: 'Settings', path: '/app/settings', icon: 'bi bi-gear-fill' },
      ]
    },
    {
      title: 'Finance', path: '', visible: true,
      menu: [
        { title: 'Settlement Ledgers', path: '/app/ledgers', icon: 'bi bi-book' },
        { title: 'Reconciliation', path: '/app/settlements', icon: 'bi bi-book' },
        { title: 'Reports', path: '/app/reports', icon: 'bi bi-card-list' },
      ]
    },
    {
      title: 'Configuration', path: '', visible: true,
      menu: [
        { title: 'Country', path: '/app/country', icon: 'bi bi-globe' },
        { title: 'Currency', path: '/app/currency', icon: 'bi bi-currency-dollar' },
        { title: 'Provider', path: '/app/provider', icon: 'bi bi-envelope' },
      ]
    },
    {
      title: 'Users', path: '', visible: true,
      menu: [
        { title: 'Users', path: '/app/users', icon: 'bi bi-people' },
        { title: 'RBAC', path: '/app/rbac', icon: 'bi bi-controller' },
        { title: 'MFA', path: '/app/mfa', icon: 'bi bi-shield-lock' },
        { title: 'Security Questions', path: '/app/security-questions', icon: 'bi bi-question-circle' },
      ]
    },
    {
      title: 'Airalo ESIM', path: '', visible: true,
      menu: [
        { title: 'Packages', path: '/app/packages', icon: 'bi bi-box' },
        { title: 'Orders', path: '/app/orders', icon: 'bi bi-cart' },
        { title: 'SIMs', path: '/app/sims', icon: 'bi bi-sim' },
        { title: 'Check Balance', path: '/app/balance', icon: 'bi bi-currency-dollar' },
      ]
    },
    {
      title: 'Billers', path: '', visible: true,
      menu: [
        { title: 'Billers', path: '/app/bills', icon: 'bi bi-receipt' },
      ]
    },
  ];

  DepartmentBasedMenu = {
    Admin: ['all'],
    Support: ['all'],
    Tech: ['all'],
    CXO: ['/app/customers', '/app/transactions', '/app/disputes', '/app/reports'],
    Accounts: ['/app', '/app/transactions', '/app/disputes', '/app/refunds']
  };

  constructor(
    private _router: Router,
    private _auth: AuthService
  ) {
    this._router.events.subscribe((res: any) => {
      this.activeUrl = this._router.url;
    });

  }

  ngOnInit(): void {
    const vm = this;
    vm.user = vm._auth.getUser();
    const allowedPaths = vm.DepartmentBasedMenu[vm.user.department] || [];
    if (!allowedPaths.includes('all')) {
      vm.sideMenu = vm.sideMenu.map(group => ({
        ...group,
        menu: group.menu.filter((m: any) => allowedPaths.includes(m.path))
      })).filter((group: any) => group.menu.length > 0);
    }
  }

  onLogout() {
    const vm = this;
    vm._auth.logout();
  }

}